import React from 'react';
import '../../../scss/newFeatures/latest.scss';

export default function Latest() {
    return <div className="latest-features">
        <div class="middle">
            <h1 className="coming-soon">COMING SOON</h1>
            <hr/>
            <p>35 days</p>
        </div>
        <div class="bottom-left">
            <p>Rasif Sahl</p>
        </div>
    </div>
}